import React, { useEffect, useState } from "react";

import styled, { css } from "styled-components";

import Button from "components/atoms/Button";
import HtmlHead from "components/atoms/HtmlHead";
import Icon from "components/atoms/Icon";
import Placeholder from "components/atoms/Placeholder";
import Alert from "components/atoms/alert/Alert";
import ToggleSwitch from "components/atoms/input/ToggleSwitch";
import Text from "components/atoms/text/Text";

import ServiceIntroSection from "components/organisms/landing/ServiceIntroSection";
import AbstractModal from "components/page/modal/AbstractModal";
import SpacePaymentNewModal from "components/page/modal/SpacePaymentNewModal";
import GuestUserLayout from "components/templates/GuestUserLayout";
import LoginUserLayout from "components/templates/LoginUserLayout";

import Constants from "utils/constants";
import { useDevice } from "utils/device";
import { userCheck } from "utils/request/auth";
import { getPaymentPlan } from "utils/request/payment";
import { getSpace } from "utils/request/space";

const Body = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: ${(props) => (props.isLoggedIn ? "calc(100vh - 56px)" : "unset")};
    overflow: auto;
`;

const ContentsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    width: 100%;
    height: fit-content;

    ${(props) =>
        props.device.isTabletOrPC &&
        css`
            padding: 0;
        `};
`;

const WidthLimit = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    max-width: 767px;

    ${(props) =>
        props.device.isTabletOrPC &&
        css`
            padding: 0 40px;
        `};

    ${(props) =>
        props.device.isPC &&
        css`
            padding: 0 80px;
            max-width: 1080px;
        `};
`;

const MobileWidthLimit = styled.div`
    padding: 0 24px;

    ${(props) =>
        props.device.isTabletOrPC &&
        css`
            padding: 0;
        `};
`;

// 타이틀 섹션

const TitleSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 24px 0 0 0;

    ${(props) =>
        props.device.isTabletOrPC &&
        css`
            margin: 40px 0 0 0;
        `};

    ${(props) =>
        props.device.isPC &&
        css`
            align-items: flex-start;
        `};
`;

const TitleSectionTitle = styled(Text).attrs({
    variant: "body-md-400",
    color: "var(--color-Grey1)",
    margin: "0 0 8px 0",
})``;

const TitleSectionText = styled(Text).attrs((props) => ({
    variant: "title-md-500",
    textAlign: props.device.isPC ? "left" : "center",
}))``;

const TitleColor = styled.span`
    color: var(--color-Key);
`;

//region: 플랜 카드 섹션

const CardSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 40px 0 0 0;
    padding: 0 24px;
    overflow-x: auto;

    ${(props) =>
        props.device.isTabletOrPC &&
        css`
            padding: 0;
        `};
`;

const CardItem = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 8px 0 0;
    width: calc(33% - 4px);
    height: 470px;
    min-width: 240px;
    background-color: var(--color-White);
    border: solid 1px var(--color-Outline);
    border-radius: 8px;

    ${(props) =>
        props.device.isTabletOrPC &&
        css`
            margin: 0;
            min-width: calc(33% - 4px);
        `};
`;

const CardHeader = styled.div`
    padding: 12px 12px;
    width: 100%;
    background-color: ${(props) => (props.isSubscribe ? "var(--color-Key)" : "var(--color-Base2)")};
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;

    ${(props) =>
        props.device.isPC &&
        css`
            padding: 16px 12px;
        `};
`;

const CardSubHeader = styled.div`
    padding: 12px 12px;
    border-bottom: solid 1px var(--color-Outline);
    ${(props) =>
        props.device.isPC &&
        css`
            padding: 16px 12px;
        `};
`;

const CardContentsWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
    align-items: left;
    padding: 0 12px 12px 12px;
    width: 100%;

    ${(props) =>
        props.device.isPC &&
        css`
            padding: 0 16px 16px 16px;
        `};
`;

const PriceWrap = styled.div`
    display: flex;
    align-items: center;
    margin: 16px 0 0 0;
`;

const ToggleWrap = styled.div`
    margin: 16px 0 0 0;
    display: flex;
`;

const CardButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    min-height: 32px;
    background-color: var(--color-Button2);
    border: solid 1px var(--color-Button2);
    border-radius: 4px;
    transition: all 120ms ease-in;

    &:hover {
        background-color: var(--color-ButtonHover2);
        border: solid 1px var(--color-ButtonHover2);
    }
    &:disabled {
        background-color: var(--color-Grey2);
        border: none;

        div {
            color: var(--color-White);
        }
    }

    ${(props) =>
        props.device.isPC &&
        css`
            height: 40px;
            min-height: 40px;
        `};
`;

const CardButtonText = styled(Text).attrs({
    variant: "body-md-400",
    color: "var(--color-White)",
})``;

const CardHeaderTitleText = styled(Text).attrs({
    variant: "title-lg",
    color: "var(--color-Black)",
    textAlign: "center",
    fontWeight: "500",
})``;

const CardHeaderBodyText = styled(Text).attrs({
    variant: "body-sm-400",
})``;

const CardHeaderGeneralText = styled(Text).attrs({
    variant: "body-md-400",
    color: "var(--color-SubBlack)",
})``;

const FeatureText = styled(Text).attrs({
    variant: "body-sm-400",
})`
    margin-left: 12px;
`;

const FeatureList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 24px 0 24px 0;
`;
const FeatureItem = styled.li`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
`;

const BannerBox = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px 0 0 0;
    padding: 24px;
    width: 100%;
    background-color: var(--color-InfoBox);
    border-radius: 8px;
    border: solid 1px var(--color-Outline);

    ${(props) =>
        props.device.isPC &&
        css`
            padding: 24px;
        `};
`;
const BannerContent = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
`;
const BannerText = styled(Text).attrs({
    variant: "title-lg",
    color: "var(--color-Black)",
    fontWeight: "500",
})``;

const BannerSubText = styled(Text).attrs({
    variant: "body-sm-400",
    color: "var(--color-Grey1)",
})`
    margin: 0px 16px;
`;

function PlanPage(props) {
    const device = useDevice();

    const [user, setUser] = useState({});
    const [plan, setPlan] = useState([]);

    const [userPlan, setUserPlan] = useState([]);

    const [initPlanStatus, setInitPlanStatus] = useState(false);
    const [showSubscribeModal, setShowSubscribeModal] = useState({
        show: false,
        isGroupPlan: false,
    });

    const isLoggedIn = localStorage.getItem("token") ? true : false;
    const ContainerComponent = isLoggedIn ? LoginUserLayout : GuestUserLayout;

    useEffect(() => {
        const initialize = async () => {
            await initPlan();

            if (isLoggedIn) {
                await initUserPlan();
            }

            setInitPlanStatus(true);
        };

        initialize();

        const refetchOnFocus = () => {
            if (!document.hidden) {
                if (isLoggedIn) initUserPlan();
            }
        };

        window.addEventListener("focus", refetchOnFocus);
        document.addEventListener("visibilitychange", refetchOnFocus);
        return () => {
            window.removeEventListener("focus", refetchOnFocus);
            document.removeEventListener("visibilitychange", refetchOnFocus);
        };
    }, [isLoggedIn]);

    const initPlan = async () => {
        const plan_data = await getPaymentPlan();
        setPlan(plan_data);
    };

    const initUserPlan = async () => {
        const user_data = await userCheck();
        setUser(user_data);

        const spaces = await getSpace();
        const paid_spaces = spaces.filter(
            (s) =>
                s.my_member_info.role === Constants.SPACE_MEMBER_ROLE_ADMIN &&
                s.status === Constants.SPACE_STATUS_ACTIVE &&
                s.plan.id !== Constants.FREE_PLAN,
        );

        setUserPlan(paid_spaces.map((s) => s.plan));
    };

    const openSubscribeModal = (planId) => {
        if (!user.email) {
            Alert("warn", "에러", "로그인 후 이용해주세요.");
            return;
        }

        setShowSubscribeModal({
            show: true,
            isGroupPlan: planId === Constants.GROUP_PLAN,
        });
    };

    const renderSubscribeButton = (type) => {
        if (user.email) {
            if (userPlan.length === 0) {
                // 유저가 구독중인 유료 플랜이 없을때
                if (type === "free") {
                    return (
                        <CardButton device={device} disabled={true}>
                            <CardButtonText>이용중</CardButtonText>
                        </CardButton>
                    );
                } else if (type === "paid") {
                    return (
                        <CardButton
                            device={device}
                            onClick={(e) => openSubscribeModal(Constants.PAID_PLAN)}
                            disabled={false}
                        >
                            <CardButtonText>구독하기</CardButtonText>
                        </CardButton>
                    );
                } else if (type === "group") {
                    return (
                        <CardButton
                            device={device}
                            onClick={(e) => openSubscribeModal(Constants.GROUP_PLAN)}
                            disabled={false}
                        >
                            <CardButtonText>구독하기</CardButtonText>
                        </CardButton>
                    );
                }
            } else {
                // 유저가 유료 플랜을 사용중일때
                if (type === "free") {
                    return;
                } else if (type === "paid") {
                    return (
                        <CardButton
                            device={device}
                            onClick={(e) => openSubscribeModal(Constants.PAID_PLAN)}
                            disabled={userPlan.find((plan) => plan.id === Constants.PAID_PLAN)}
                        >
                            <CardButtonText>
                                {userPlan.find((plan) => plan.id === Constants.PAID_PLAN) ? "이용중" : "구독하기"}
                            </CardButtonText>
                        </CardButton>
                    );
                } else if (type === "group") {
                    return (
                        <CardButton
                            device={device}
                            onClick={(e) => openSubscribeModal(Constants.GROUP_PLAN)}
                            disabled={userPlan.find((plan) => plan.id === Constants.GROUP_PLAN)}
                        >
                            <CardButtonText>
                                {userPlan.find((plan) => plan.id === Constants.GROUP_PLAN) ? "이용중" : "구독하기"}
                            </CardButtonText>
                        </CardButton>
                    );
                }
            }
        } else {
            return (
                <CardButton device={device} onClick={(e) => (window.location.href = `/login?next=/plan`)}>
                    <CardButtonText>시작하기</CardButtonText>
                </CardButton>
            );
        }
    };

    const [paidPlanMonth, setPaidPlanMonth] = useState(1);
    const [groupPlanMonth, setGroupPlanMonth] = useState(1);

    return (
        <ContainerComponent minWidth={"unset"}>
            <HtmlHead title={"요금 안내"} />
            <Body isLoggedIn={isLoggedIn}>
                <ContentsWrapper device={device}>
                    <WidthLimit device={device}>
                        {/* 타이틀 섹션 */}
                        <MobileWidthLimit device={device}>
                            <TitleSection device={device}>
                                <TitleSectionTitle>요금안내</TitleSectionTitle>
                                <TitleSectionText device={device}>
                                    연구 관리의 기본부터 AI 연구 지원까지.
                                    <br />
                                    <TitleColor>Basic으로 시작하고, 필요할 때 Pro로 업그레이드하세요.</TitleColor>
                                </TitleSectionText>
                            </TitleSection>
                        </MobileWidthLimit>

                        {/* 플랜 카드 섹션 */}
                        <CardSection device={device}>
                            {/* 무료 플랜 */}
                            <CardItem device={device}>
                                <CardHeader device={device} isSubscribe={userPlan.length === 0}>
                                    <CardHeaderTitleText>
                                        {initPlanStatus ? (
                                            "Basic"
                                        ) : (
                                            <Placeholder style={{ width: "100px", height: "20px" }} />
                                        )}
                                    </CardHeaderTitleText>
                                </CardHeader>
                                <CardSubHeader device={device}>
                                    <CardHeaderGeneralText>
                                        {initPlanStatus ? (
                                            "참고문헌 관리에 적합한 무료 요금제"
                                        ) : (
                                            <Placeholder style={{ width: "150px", height: "20px" }} />
                                        )}
                                    </CardHeaderGeneralText>
                                    <PriceWrap>
                                        {initPlanStatus ? (
                                            <>
                                                <CardHeaderTitleText>0원 </CardHeaderTitleText>
                                                <CardHeaderBodyText>&nbsp; / 월</CardHeaderBodyText>
                                            </>
                                        ) : (
                                            <CardHeaderTitleText>
                                                <Placeholder style={{ width: "70px", height: "20px" }} />
                                            </CardHeaderTitleText>
                                        )}
                                    </PriceWrap>
                                    <div style={{ marginTop: "16px", height: "23px" }}>&nbsp;</div>
                                </CardSubHeader>
                                <CardContentsWrap device={device}>
                                    <FeatureList>
                                        {initPlanStatus ? (
                                            <>
                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>200MB 저장소</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>참고문헌 저장 및 관리</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>폴더 및 태그를 통한 분류 관리</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>PDF 하이라이트 및 메모 추가</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>논문 DB 검색 및 연관 논문 추천</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>연구노트 작성 및 참고문헌 인용 관리</FeatureText>
                                                </FeatureItem>
                                            </>
                                        ) : (
                                            <>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                            </>
                                        )}
                                    </FeatureList>
                                    {renderSubscribeButton("free")}
                                </CardContentsWrap>
                            </CardItem>
                            {/* 유료 플랜 */}
                            <CardItem device={device}>
                                <CardHeader
                                    device={device}
                                    isSubscribe={userPlan.find((plan) => plan.id === Constants.PAID_PLAN)}
                                >
                                    <CardHeaderTitleText>
                                        {initPlanStatus ? (
                                            plan.find((item) => item.id === Constants.PAID_PLAN)?.name
                                        ) : (
                                            <Placeholder style={{ width: "100px", height: "20px" }} />
                                        )}
                                    </CardHeaderTitleText>
                                </CardHeader>
                                <CardSubHeader device={device}>
                                    <CardHeaderGeneralText>
                                        {initPlanStatus ? (
                                            "AI 기능을 활용하는 유료 요금제"
                                        ) : (
                                            <Placeholder style={{ width: "150px", height: "20px" }} />
                                        )}
                                    </CardHeaderGeneralText>
                                    <PriceWrap>
                                        {initPlanStatus ? (
                                            <>
                                                <CardHeaderTitleText>
                                                    {paidPlanMonth === 1
                                                        ? plan
                                                              .find((item) => item.id === Constants.PAID_PLAN)
                                                              .price.toLocaleString("ko-KR")
                                                        : (
                                                              plan.find((item) => item.id === Constants.PAID_PLAN)
                                                                  .price * 0.9
                                                          ).toLocaleString("ko-KR")}
                                                    원{" "}
                                                </CardHeaderTitleText>
                                                <CardHeaderBodyText>&nbsp; / 월 (VAT 포함)</CardHeaderBodyText>
                                            </>
                                        ) : (
                                            <CardHeaderTitleText>
                                                <Placeholder style={{ width: "100px", height: "20px" }} />
                                            </CardHeaderTitleText>
                                        )}
                                    </PriceWrap>
                                    <ToggleWrap>
                                        <ToggleSwitch
                                            options={[
                                                { label: "1개월", value: 1 },
                                                { label: "3개월", value: 3 },
                                            ]}
                                            value={paidPlanMonth}
                                            onChange={(e) => {
                                                setPaidPlanMonth(e);
                                            }}
                                        />
                                    </ToggleWrap>
                                </CardSubHeader>
                                <CardContentsWrap device={device}>
                                    <FeatureList>
                                        {initPlanStatus ? (
                                            <>
                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>Basic의 모든 기능</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>20GB 저장소</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>참고문헌 자동 분석(AI 요약 및 비평)</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>AI 기반 PDF 리뷰(요약, 번역, 설명, 질의)</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>연구 노트 AI 글쓰기 도구</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>관련 연구 초안 작성</FeatureText>
                                                </FeatureItem>
                                            </>
                                        ) : (
                                            <>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                            </>
                                        )}
                                    </FeatureList>
                                    {renderSubscribeButton("paid")}
                                </CardContentsWrap>
                            </CardItem>
                            {/* 단체 플랜 */}
                            <CardItem device={device}>
                                <CardHeader
                                    device={device}
                                    isSubscribe={userPlan.find((plan) => plan.id === Constants.GROUP_PLAN)}
                                >
                                    <CardHeaderTitleText>
                                        {initPlanStatus ? (
                                            plan.find((item) => item.id === Constants.GROUP_PLAN)?.name
                                        ) : (
                                            <Placeholder style={{ width: "100px", height: "20px" }} />
                                        )}
                                    </CardHeaderTitleText>
                                </CardHeader>
                                <CardSubHeader device={device}>
                                    <CardHeaderGeneralText>
                                        {initPlanStatus ? (
                                            "단체 결제 가능한 할인 요금제"
                                        ) : (
                                            <Placeholder style={{ width: "150px", height: "20px" }} />
                                        )}
                                    </CardHeaderGeneralText>
                                    <PriceWrap>
                                        {initPlanStatus ? (
                                            <>
                                                <CardHeaderTitleText>
                                                    {groupPlanMonth === 1
                                                        ? (
                                                              plan.find((item) => item.id === Constants.GROUP_PLAN)
                                                                  .price * 0.9
                                                          ).toLocaleString("ko-KR")
                                                        : (
                                                              plan.find((item) => item.id === Constants.GROUP_PLAN)
                                                                  .price * 0.8
                                                          ).toLocaleString("ko-KR")}
                                                    원{" "}
                                                </CardHeaderTitleText>
                                                <CardHeaderBodyText>&nbsp; / 월 (VAT 포함)</CardHeaderBodyText>
                                            </>
                                        ) : (
                                            <CardHeaderTitleText>
                                                <Placeholder style={{ width: "100px", height: "20px" }} />
                                            </CardHeaderTitleText>
                                        )}
                                    </PriceWrap>
                                    <ToggleWrap>
                                        <ToggleSwitch
                                            options={[
                                                { label: "1개월", value: 1 },
                                                { label: "3개월", value: 3 },
                                            ]}
                                            value={groupPlanMonth}
                                            onChange={(e) => {
                                                setGroupPlanMonth(e);
                                            }}
                                        />
                                    </ToggleWrap>
                                </CardSubHeader>
                                <CardContentsWrap device={device}>
                                    <FeatureList>
                                        {initPlanStatus ? (
                                            <>
                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>Pro의 모든 기능</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>2명 이상 할인 요금제 </FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>3개월 장기 결제 시 10% 추가 할인</FeatureText>
                                                </FeatureItem>

                                                <FeatureItem>
                                                    <Icon name="check" size="12px" color="var(--color-Grey1)" />
                                                    <FeatureText>그룹 멤버 초대 및 관리</FeatureText>
                                                </FeatureItem>
                                            </>
                                        ) : (
                                            <>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                                <FeatureItem>
                                                    <Placeholder style={{ width: "120px", height: "16px" }} />
                                                </FeatureItem>
                                            </>
                                        )}
                                    </FeatureList>
                                    {renderSubscribeButton("group")}
                                </CardContentsWrap>
                            </CardItem>
                        </CardSection>

                        {/* region: 배너 */}
                        {!isLoggedIn && (
                            <MobileWidthLimit device={device}>
                                <BannerBox device={device}>
                                    <BannerContent>
                                        <BannerText>회원가입시 7일 무료 쿠폰을 드립니다.</BannerText>
                                        <BannerSubText>Pro 요금제 전용</BannerSubText>
                                    </BannerContent>

                                    <Button
                                        onlyText
                                        width={"200px"}
                                        height={"40px"}
                                        bgColor={"var(--color-Button2)"}
                                        hoverBgColor={"var(--color-ButtonHover2)"}
                                        fontColor={"var(--color-White)"}
                                        buttonText={"회원가입"}
                                        onClick={(e) => {
                                            window.location.href = "/signup?next=/plan";
                                        }}
                                    />
                                </BannerBox>
                            </MobileWidthLimit>
                        )}
                    </WidthLimit>
                </ContentsWrapper>
                <ServiceIntroSection AOSDisabled={isLoggedIn} />
            </Body>

            {showSubscribeModal.show && (
                <AbstractModal
                    modalTitle="요금제 결제"
                    width={500}
                    height={640}
                    exitModal={(e) => setShowSubscribeModal({ show: false, isGroupPlan: false })}
                >
                    <SpacePaymentNewModal
                        isGroupPlan={showSubscribeModal.isGroupPlan}
                        user={user}
                        exitModal={(e) => setShowSubscribeModal({ show: false, isGroupPlan: false })}
                    />
                </AbstractModal>
            )}
            <div
                style={{
                    display: "none",
                    overFlow: "scroll",
                    position: "fixed",
                    zIndex: 10000,
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    padding: "120px 0",
                    background: "rgba(0,0,0,.48)",
                    boxSizing: "border-box",
                }}
                id={"iamport-modal"}
            ></div>
        </ContainerComponent>
    );
}

export default PlanPage;
